import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import infoGuides from '../data/infoGuides';
import { REF_QUERY_PARAM, REF_RELATED_SEARCH } from '../../constants';

const MAX_RELATED_GUIDES = 3;

/**
 * Reverse link from an SSR /search/{slug} page into any /info/* buying guide that
 * covers the same product/brand (docs/ssr-seo-distribution-plan.md Phase 1 item 3) -
 * /info/* pages already link out to search pages, this closes the loop the other way
 * so Google's crawler (and real visitors) can move between the two page types.
 * Renders nothing when no guide matches, so it never adds an empty section.
 */
export default function RelatedGuides({ searchTerm }) {
  if (!searchTerm) return null;

  const normalizedTerm = searchTerm.toLowerCase();
  const matches = infoGuides
    .filter((guide) => guide.keywords.some((keyword) => normalizedTerm.includes(keyword)))
    .slice(0, MAX_RELATED_GUIDES);

  if (matches.length === 0) return null;

  return (
    <section className="max-w-3xl mx-auto px-4 py-6" aria-label="מדריכים קשורים">
      <h2 className="text-base font-semibold text-gray-700 mb-2">מדריכים קשורים</h2>
      <ul className="flex flex-wrap gap-2">
        {matches.map((guide) => (
          <li key={guide.path}>
            <Link
              to={`${guide.path}?${REF_QUERY_PARAM}=${REF_RELATED_SEARCH}`}
              className="inline-block px-3 py-1.5 rounded-full bg-gray-100 text-gray-800 text-sm hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
            >
              {guide.title}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

RelatedGuides.propTypes = {
  searchTerm: PropTypes.string,
};
